module.exports = __webpack_public_path__ + "img/fj.8f135d26.png";